/* istanbul ignore file */
import { useDispatch as useAppDispatch } from 'react-redux';
import { AppDispatch } from '../store/types';

export const useDispatch = () => {
  const dispatch = useAppDispatch<AppDispatch>();
  return dispatch;
};
